/**
 * This is responsible handling Vue-powered messages intended for the user interface.
 *
 * @param uiMessageNames
 * @param playVoice
 * @return void
 */
window.UiMessageHandler = function(uiMessageNames, playVoice = false)
{
    /**
     * Accepts an array of message names and returns an array of empty message objects to be appended
     * to a Vue skeleton's data property.
     *
     * @param array $names
     * @return array
     */
    this.getEmpties = function(names)
    {
        var empties = {};

        for (var i in names)
        {
            empties[names[i]] =
            {
                message: null,
                timer: null
            };
        }

        return empties;
    };

    /**
     * @var Object
     *
     * Define the base Vue skeleton to be extended.
     */
    this.VueSkeleton =
    {
        mounted: function()
        {
            // Attach audio.
            this.alarmWarning = document.getElementById('alarm-warning');

            // Buffer audio.
            if (this.alarmWarning)
            {
                this.alarmWarning.load();
            }
        },

        data:
        {
            uiMessages: this.getEmpties(uiMessageNames),

            /**
             * Flags whether to play a voice audio of the message.
             *
             * @var bool
             */
            playVoice: playVoice,
        },

        methods:
        {
            /**
             * Get the message for a given named message.
             *
             * @param name
             * @return string
             */
            message: function(name)
            {
                if (typeof this.uiMessages[name] !== 'undefined')
                {
                    return this.uiMessages[name].message;
                }

                throw 'A UIMessageHandler message property named \''+ name +'\' has not been defined.';
            },

            /**
             * Set the message for a given named message.
             *
             * @param name
             * @param message
             * @param delay
             * @param playWarning
             */
            setMessage: function(name, message, delay, playWarning)
            {
                if (typeof this.uiMessages[name] === 'undefined')
                {
                    throw 'A UIMessageHandler message property named \''+ name +'\' has not been defined.';
                }

                if (this.alarmWarning && playWarning)
                {
                    this.alarmWarning.play();
                }

                var uiMessage = this.uiMessages[name];

                if (uiMessage.message !== null)
                {
                    return;
                }

                uiMessage.message = message;

                uiMessage.timer = setTimeout(function()
                {
                    clearTimeout(uiMessage.timer);
                    uiMessage.message = null;
                    uiMessage.timer = null;
                }, delay || 6000);

                if (this.playVoice)
                {
                    this.playTextToSpeech(message);
                }
            },

            /**
             * Set a permanent message for a given named message.
             *
             * @param string name
             * @param string message
             */
            setPermanentMessage: function(name, message)
            {
                var uiMessage = this.uiMessages[name];

                uiMessage.message = message;
            },

            /**
             * Courtesy of ChatGPT.
             *
             * @param text
             */
            async playTextToSpeech(text) {
                try {
                    const response = await fetch('/dshell/api/text-to-speech', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'audio/mpeg',
                            'X-CSRF-TOKEN': Laravel.csrfToken,
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify({ text }),
                    });

                    if (!response.ok) {
                        throw new Error('Failed to generate audio.');
                    }

                    // Wait for the entire audio data to be received
                    const audioData = await response.blob();

                    // Create a URL for the Blob and play it
                    const audioUrl = URL.createObjectURL(audioData);
                    const audio = new Audio(audioUrl);

                    // Optional: Add event listeners to handle playback errors or interruptions
                    audio.addEventListener('error', (e) => {
                        console.error('Audio playback error:', e);
                    });

                    audio.play();

                } catch (error) {
                    console.error('Error in playTextToSpeech:', error);
                    // Handle errors as needed
                }
            }// playTextToSpeech()
        }
    };
};
